jQuery(document).ready(function($){

    // Auto scroll through product thumbnail images
    setInterval(function() {    
        var $activeThumb = $('.flex-control-nav .flex-active');
        var $parent = $activeThumb.parent('li');
        if($parent.next().length) {
            $next = $parent.next();
        } else {
            $next = $('.flex-control-nav li:first-child');
        }

        $('img', $next).trigger('click');;
    }, 8000);
});